<nav class="navbar topnavbar" role="navigation">
  <!-- START navbar header-->
  <div class="navbar-header">
    <div class="navbar-brand  d-none d-md-flex d-lg-flex d-xl-flex" href="#/">
      <div class="brand-logo">
        <a href="#/" class="aside-logo">
          <h3 class="pd-t-10" style="margin:0px;">MIGI</h3>
        </a>
      </div>
      <a class="nav-link" trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
        <em class="fas fa-bars" style="color:red"></em>
      </a>
    </div>
  </div>
  <!-- END navbar header-->
  <!-- START Left navbar-->
  <ul class="navbar-nav mr-auto flex-row">
    <li class="nav-item">
      <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
      <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
      <a class="nav-link sidebar-toggle d-md-none" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
        <em class="fas fa-bars" style="color:red"></em>
      </a>
    </li>
    <!-- START User avatar toggle-->
    <li class="nav-item d-none d-md-block">
      <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
      <a class="nav-link app-name">
        TÒA SOẠN BÁO VĨNH PHÚC
      </a>
    </li>
    <!-- END User avatar toggle-->

  </ul>
  <!-- END Left navbar-->
  <!-- START Right Navbar-->
  <ul class="navbar-nav flex-row">
    <li class="nav-item">
      <a class="nav-link" title="Cổng tin tức" href="http://baovinhphuc.com.vn">
        <em class="fa-13x mr-2 fas fa-chalkboard" style="color: #2c2e74;"></em>
        Cổng tin tức
      </a>
    </li>
    <li class="nav-item dropdown dropdown-list" dropdown>
      <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" title="Thông tin người dùng" dropdownToggle>
        <em class="fa-2x mr-2 fas fa-user-circle" style="color: #2c2e74;"></em>

      </a>
      <!--<ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">

      </ul>-->
      <!-- START Dropdown menu-->
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right animated flipInX">
        <li>
          <!-- START list group-->
          <div class="list-group">

            <a class="list-group-item" [routerLink]="['/quantri/doimatkhau']">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-exchange"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">Đổi mật khẩu</p>
                  <p class="m0 text-muted">
                    <small>Thay đổi mật khẩu tài khoản</small>
                  </p>
                </div>
              </div>
            </a>

            <a class="list-group-item" (click)="logout()">
              <div class="media">
                <div class="align-self-start mr-2">
                  <i class="fa fa-external-link"></i>
                </div>
                <div class="media-body clearfix">
                  <p class="m0">Đăng xuất</p>
                  <p class="m0 text-muted">
                    <small>Thay tài khoản</small>
                  </p>
                </div>
              </div>
            </a>




          </div>
          <!-- END list group-->
        </li>
      </ul>
      <!-- END Dropdown menu-->
    </li>

  </ul>


</nav>
